import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';

import { modifyPageLayoutComponents } from '../../PageLayout';

import SkuFiltersHeader from './SkuFiltersHeader';
import template from './SkuFilters.rt';
import templateContentHeader from './SkuFiltersContentHeader.rt';
import {saveFilterGroup, getFilters, enableFilterGroup, expandFilterGroup, updateExpandedFilterGroupProp,
    setActiveFilterGroupIcon, tryAddNewFilterGroup, cancelFilterGroupEdit,
    deleteFilterGroup} from './SkuFiltersActions';
import { filterGroupVisualStylePopup, errorBox_Show, messageBox_Show } from '../../../actions/A_Popups';
import * as Misc from '../../../misc';
import { isImageFile, bkgImage } from '../../../utilities/helpers';
import { AccessRights } from '../../../schemas/accessRightsModel';
import PS from '../../ProjectScope/ProjectScopeActionsNew';
import {loadingDialog_show} from "../../../actions";

import { getApiConfig } from "../../../utilities";

let abortablePromise = null;

const mapStateToProps = state => {
    const { skuFilters } = state;
    return {
        term: skuFilters.term,
        hasGroups: skuFilters.groups && skuFilters.groups.size > 0,
        groups: skuFilters.groups && skuFilters.groups.toJS(),
        totalPages: skuFilters.totalPages,
        filterGroupUpdatedSuccessful: skuFilters.filterGroupUpdatedSuccessful,
        expandedFilterGroup: skuFilters.expandedFilterGroup ? skuFilters.expandedFilterGroup.toJS() : null,
        expandedFilterGroupID: skuFilters.expandedFilterGroup ? skuFilters.expandedFilterGroup.get('id') : 0,
        imagesSeed: skuFilters.imagesSeed,
        //loadFeaturesGroups: (singleRequest) => dispatch(PS.loadFeaturesGroups(singleRequest)),
        AR: AccessRights.get(state),
        asCustomer: state.asCustomer
    }
};

const mapDispatchToProps = dispatch => ({
    getFilters: (page, term) => dispatch(getFilters(page, term)),
    enableFilterGroup: (filterGroupID, enable) => dispatch(enableFilterGroup(filterGroupID, enable)),
    expandFilterGroup: (filterGroupID) => dispatch(expandFilterGroup(filterGroupID)),
    updateExpandedFilterGroupProp: (propName, value) => dispatch(updateExpandedFilterGroupProp(propName, value)),
    filterGroupVisualStylePopup: (show, style) => dispatch(filterGroupVisualStylePopup(show, style)),
    errorBox_Show: config => dispatch(errorBox_Show(config)),
    setActiveFilterGroupIcon: icon => dispatch(setActiveFilterGroupIcon(icon)),
    saveFilterGroup: group => dispatch(saveFilterGroup(group)),
    tryAddNewFilterGroup: () => dispatch(tryAddNewFilterGroup()),
    cancelFilterGroupEdit: (id) => dispatch(cancelFilterGroupEdit(id)),
    messageBox_Show: (show, type, title, message, buttons) => dispatch(messageBox_Show(show, type, title, message, buttons)),
    deleteFilterGroup: filterGroupID => dispatch(deleteFilterGroup(filterGroupID)),
    loadingDialog_show: (show, title, text) => dispatch(loadingDialog_show(show, title, text)),
});

class SkuFilters extends Component {

    static propTypes = {
        getFilters: PropTypes.func.isRequired
    };
 
    constructor(props) {
        super(props);

        this.state = {
            featureGroups: []
        }

        this.getGroups();
    }

    getGroups () {
        const {AR, subscriptionsInfo} = this.props;
        const fabricatorId = this.props.asCustomer.data ? this.props.asCustomer.data.fabricatorId : AR.auth.fabricatorId;
        const {masterFabricatorId} = AR.auth;

        if (abortablePromise) {
            abortablePromise.abort();
            abortablePromise = null;
        }

        abortablePromise = getApiConfig('SkuFilters');
        abortablePromise.get(`/features-groups/${fabricatorId}/${masterFabricatorId}`)
            .then(data => {
                this.setState({ featureGroups: data.groups });
                console.log(data);
                this.props.loadingDialog_show(false);
            });
    }

    componentDidMount() {
        this.props.loadingDialog_show(true, 'Loading...', 'Loading features groups, this will take just a moment.');
        this.props.getFilters(this.props.page, this.props.term);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.filterGroupUpdatedSuccessful) {
            this.props.getFilters(this.props.page, this.props.term);
        }
    }

    handlePaginate = page => {
        this.props.getFilters(page, this.props.term);
    };

    toggleGroupEnabled = (filterGroupID, value) => {
        this.props.enableFilterGroup(filterGroupID, !value);
    }

    expandFilterGroup = (filterGroupID) => {
        this.props.expandFilterGroup(filterGroupID);
    }

    showFilterGroupVisualTypeSelectionPopup = () => {
        this.props.filterGroupVisualStylePopup(true, this.props.expandedFilterGroup.visualStyle);
    }

    selectGroupIcon = (e) => {
        Misc.ignoreDefault(e);
        ReactDOM.findDOMNode(this.refs.fileLoader).click();
    }

    handleUploadFieldChange = (e) => {
        let files = null;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }

        if (!files || !files.length) {
            console.log("No Files selected");
            return;
        }

        const file = files[0];

        if (file.size > 12 * 1024 * 1024) {
            this.props.errorBox_Show({
                title: 'Error',
                text: 'File too large.',
                rightButtonText: 'OK',
                isRightButtonVisible: true
            });
            return;
        }

        if (!isImageFile(file.name)) {
            this.props.errorBox_Show({
                title: 'Error',
                text: 'File is not an image.',
                rightButtonText: 'OK',
                isRightButtonVisible: true
            });
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            ReactDOM.findDOMNode(this.refs.iconHolder).style.backgroundImage = bkgImage(reader.result);
        };
        reader.readAsDataURL(file);

        this.props.setActiveFilterGroupIcon(file);
    };

    saveGroup = () => {
        this.props.saveFilterGroup(this.props.expandedFilterGroup);
    }

    confirmDeleteGroup = filterGroupID => {
        this.props.messageBox_Show(true, 'error', 'Delete', 'Are you sure you want to delete the filter group?',
            [{
                text: 'Yes',
                onClick: () => {
                    this.props.deleteFilterGroup(filterGroupID);
                    this.props.messageBox_Show();
                }
            }, {
                text: 'Cancel',
                onClick: () => this.props.messageBox_Show()
            }]);
    }

    goToFilterGroupItems = (filterGroupID, featureGroup) => {
        hashHistory.push('/sku-filterGroupItems?filterGroupID=' + filterGroupID + '&featureGroup=' + featureGroup);
    }

    handleFeatureGroupChange = (g, e) => { 
        if (abortablePromise) {
            abortablePromise.abort();
            abortablePromise = null;
        } 

        abortablePromise = getApiConfig('SkuFilters');
        this.props.loadingDialog_show(true,  'Loading...', 'Updating feature group, this will take just a moment.');
        abortablePromise.post( {filterId: g.id, featureGroupName: e.target.value}, `/UpdateFeatureGroup`)
            .then(data => {
                this.props.getFilters(this.props.page, this.props.term);
                this.props.loadingDialog_show(false);
            });
    }

    render() {  
        return template.apply(this);
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

export const SkuFiltersLayoutComponents = modifyPageLayoutComponents({
    pageHeader: connector(SkuFiltersHeader),
    contentHeader: connector(templateContentHeader),
    content: connector(SkuFilters),
    pageFooter: null
});